// =====================================
//
//   messageBox Modal
//   Author: Gray
//   createtime: 2016 / 09 / 09
//   updatetime: 2016 / 09 / 09
//
// =====================================

window.InifECMobileApp.directive('messageBox', ['$rootScope', '$stateParams', '$timeout', '$ngModal', '$state',
    function($rootScope, $stateParams, $timeout, $ngModal, $state) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            var openModal = function() {

                $ngModal.openModal("message-box");
            }

            var closeModal = function() {
                $ngModal.closeModal("message-box");
            }

            var cancel = function() {

                closeModal();
                $scope.callback && $scope.callback();
            }

            var finishIdentify = function() {
                $state.go(window.STATES.HOME);
                closeModal();
                $rootScope.$broadcast("LOGIN_SUCCESS");
            }

            var goToOrder = function() {
                $state.go(window.STATES.ORDER, {orderid: $scope.orderid});
                closeModal();
            }


            var init = function() {

            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_EMAIL_MESSAGE_MODAL", function(event, data) {
                $scope.viewType = "MAIL";
                $scope.callback = data.callback;
                openModal();
            });

            $scope.$on("OPEN_MAIL_IDENTIFY_MODAL", function(event, data) {
                $scope.viewType = "IDENTIFY";
                $scope.callback = data.callback;
                openModal();
            });

            $scope.$on("OPEN_SIMPLE_MESSAGE_MODAL", function(event, data) {
                $scope.viewType = "SIMPLE";
                $scope.title = data.title;
                $scope.desc = data.desc;
                $scope.callback = data.callback;
                openModal();
            });

            $scope.$on("OPEN_ERROR_MESSAGE_MODAL", function(event, data) {
                $scope.viewType = "ERROR";
                $scope.title = data.title;
                $scope.desc = data.desc;
                $scope.callback = data.callback;
                openModal();
            });

            $scope.$on("OPEN_SUCCESS_MESSAGE_MODAL", function(event, data) {
                $scope.viewType = "SUCCESS";
                $scope.title = data.title;
                $scope.desc = data.desc;
                $scope.callback = data.callback;
                openModal();
            });

            $scope.$on("OPEN_ORDER_CREATE_SUCCESS_MODAL", function(event, data) {
                $scope.viewType = "ORDER_CREATE_SUCCESS";
                $scope.orderid = data.orderid;
                $scope.callback = data.callback;
                
                if(data.needPay) {
                    $scope.orderButtonStr = "前往付款";
                } else {
                    $scope.orderButtonStr = "查看訂單";
                }

                openModal();
            });

            $scope.$on("OPEN_ORDER_UPLOAD_ERROR_MODAL", function(event, data) {
                $scope.viewType = "ORDER_UPLOAD_ERROR";
                $scope.orderid = data.orderid;
                $scope.callback = data.callback;
                openModal();
            });            
                
            /*==========================
                Members
            ==========================*/

            $scope.viewType = "SIMPLE";
            $scope.title = "";
            $scope.desc = "";
            $scope.SECURE_INIFEC_URL = SECURE_INIFEC_URL;
            $scope.callback;
            $scope.orderButtonStr = "";

            /*==========================
                Methods
            ==========================*/
            $scope.finishIdentify = finishIdentify;
            $scope.goToOrder = goToOrder;
            $scope.cancel = cancel;

            /*==========================
                init
            ==========================*/

            init();
        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'mobile/partials/modal/message_box.html';
        _dir.controller = controller;

        return _dir;
}]);